import React from 'react';

export default class Logout extends React.Component {

    componentWillMount() {
        localStorage.removeItem('id_token');
        localStorage.removeItem('user');
        const hash = window.location.hash;
        if (Boolean(hash)) {
            const isLocked = hash.split("#")[1].includes("locked");
            if (isLocked) {
                return window.location.href = '/#locked';
            }
        }
        return window.location.href = '/';
    }

    render() {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-200">
                <div className="w-full max-w-md p-3" >
                    <div className=" bg-white shadow-md rounded px-8 py-8 pt-8 text-center">
                        <div className="spinner mb-10 mt-2"></div>
                        <div>Logging you out of your account</div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/logout.js